import { Navigate, Outlet, useLocation } from "react-router-dom";
import { ROUTES } from "../../lib/routes";
import { useUserDetails } from "@/redux/function";

const PrivateRoute = () => {
  const userData = useUserDetails();
  const location = useLocation();
  const accessToken = userData?.access;

  if (!accessToken) {
    return (
      <Navigate
        to={ROUTES.LOGIN.REDIRECT(location.pathname, location.search)}
        replace
      />
    );
  }

  return accessToken ? <Outlet /> : <Navigate to={ROUTES.LOGIN.BASE} />;
};

export default PrivateRoute;
